import { bound } from "@frui.ts/helpers";
import { watchBusy } from "@frui.ts/screens";
import { validate } from "@frui.ts/validation";
import { computed } from "mobx";
import type { UpdatedEvent } from "services/eventBus";
import type EventBus from "services/eventBus";
import type NotificationService from "services/notificationService";
import { NotificationType } from "services/notificationService";
import type SecurityService from "services/securityService";
import DetailViewModel from "./detailViewModel";

export default abstract class EditableDetailViewModel<TEntity> extends DetailViewModel<TEntity> {
  protected notificationService?: NotificationService;
  protected abstract eventBus: EventBus;
  protected abstract securityService: SecurityService;
  protected abstract updateData(): Promise<TEntity>;
  protected closeOnSave = true;

  @computed
  get isEditable() {
    return this.securityService.allowToEntity(this.modelName, "write");
  }

  protected onUpdated() {
    if (this.notificationService) {
      this.notificationService.add({ title: this.translate("updated"), type: NotificationType.SUCCESS });
    }
    this.eventBus.publish<UpdatedEvent<TEntity>>({ type: `${this.modelName}.updated`, payload: { [this.modelName]: this.item } });

    if (this.closeOnSave) {
      this.requestClose();
    }
  }

  protected validate() {
    return validate(this.item);
  }

  @bound
  @watchBusy
  async save() {
    if (this.isEditable && this.validate()) {
      try {
        const item = await this.updateData();
        this.setItem(item);
        this.onUpdated();
      } catch (e) {}
    }
  }
}
